
import { GridOverlay } from '@mui/x-data-grid';
import Empty from "../Empty";


const EmptyRows = () => {
    return (
        <GridOverlay className='gridoverlay-emptyrows'>
            <Empty text='noRecordsFound' />
        </GridOverlay>
    );
}

export default EmptyRows;
